import { HttpClient } from '@angular/common/http';
import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy
} from '@angular/core';
import { TopicType } from '@bannerflow/types.notification-service';
import { UIButtonComponent, UIRadioComponent } from '@bannerflow/ui';
import { NotificationService } from '@bannerflow/notification';
import { environment } from '../../environments/environment';

@Component({
  imports: [UIButtonComponent, UIRadioComponent],
  selector: 'test-trigger',
  template: `
    <span>Trigger a test notification</span>
    <div class="radio-wrapper">
      @for (option of options; track option) {
        <ui-radio
          style="margin-right: 5px"
          groupId="radioOptionsGroup"
          [selected]="option === selectedOption()"
          [label]="option"
          (click)="selectedOption.set(option)" />
      }
    </div>
    <ui-button
      type="primary"
      (click)="triggerTestNotification()"
      text="submit" />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .radio-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  `
})
export class TestTriggerComponent {
  private httpClient = inject(HttpClient);
  private notificationService = inject(NotificationService);
  options = Object.values(TopicType);
  selectedOption = signal<TopicType>(TopicType.ImageExport);

  triggerTestNotification(): void {
    const url = `${environment.origins['notificationServiceApi']}/notifications/test?topicType=${this.selectedOption()}`;
    this.httpClient.post(url, undefined).subscribe({
      next: () => console.log('NotificationCommand created'),
      error: error =>
        console.error('NotificationCommand creation failed', error)
    });
  }
}
